import { Currency } from '@seapoint/server/enums';
import { ComponentProps } from 'react';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountView, BeneficiaryView } from '../../../../types/entity-types';
import { EvidencePrefill } from '../../payment-flow-storage';
import { InvoiceChecksCard } from './invoice-checks-card';
import { InvoicePaymentInformationForm } from './invoice-payment-information-form';

export type InvoiceDetails = {
  totalAmount: ComponentProps<typeof InvoicePaymentInformationForm>['invoiceInformation']['totalAmount'];
  suggestedBeneficiaryId: ComponentProps<
    typeof InvoicePaymentInformationForm
  >['invoiceInformation']['suggestedBeneficiaryId'];
  invoiceReference: ComponentProps<typeof InvoicePaymentInformationForm>['invoiceInformation']['invoiceReference'];
  currency: Currency;
};

export type InvoiceDetailsWithOptionalCurrency = Omit<InvoiceDetails, 'currency'> & {
  currency?: Currency;
};

type ChecksVariantConfig =
  | {
      isVisible: false;
    }
  | {
      isVisible: true;
      variant: ComponentProps<typeof InvoiceChecksCard>['variant'];
    };

type InvoicePaymentInformationWithoutToggleProps = {
  accounts: AccountView[];
  initialSourceAccountId?: string;
  beneficiaries: BeneficiaryView[];
  invoiceDetails: InvoiceDetails;
  checksVariantConfig?: ChecksVariantConfig;
  evidencePrefill: EvidencePrefill | null;
  isLoading: boolean;
  onCancelTransfer: () => void;
  onConfirmPaymentInformation: ComponentProps<typeof InvoicePaymentInformationForm>['onSubmit'];
  onPaymentDataChange: ComponentProps<typeof InvoicePaymentInformationForm>['onPaymentDataChange'];
};

export const InvoicePaymentInformationWithoutToggle = ({
  accounts,
  initialSourceAccountId,
  beneficiaries,
  invoiceDetails,
  checksVariantConfig = { isVisible: false },
  evidencePrefill,
  isLoading,
  onCancelTransfer,
  onConfirmPaymentInformation,
  onPaymentDataChange,
}: InvoicePaymentInformationWithoutToggleProps) => {
  const { currency, totalAmount, suggestedBeneficiaryId, invoiceReference } = invoiceDetails;

  return (
    <Stack space={3} align="stretch">
      <Stack space={3} align="stretch">
        {checksVariantConfig.isVisible && <InvoiceChecksCard variant={checksVariantConfig.variant} />}

        <InvoicePaymentInformationForm
          accounts={accounts}
          initialSourceAccountId={initialSourceAccountId}
          beneficiaries={beneficiaries}
          invoiceInformation={{
            totalAmount,
            suggestedBeneficiaryId,
            invoiceReference,
          }}
          evidencePrefill={evidencePrefill}
          isLoading={isLoading}
          currency={currency}
          onCancelTransfer={onCancelTransfer}
          onSubmit={onConfirmPaymentInformation}
          onPaymentDataChange={onPaymentDataChange}
        />
      </Stack>
    </Stack>
  );
};
